const formatMilesLimit = (bookingData, t) => {
  if (!bookingData.quote) return '';

  let formattedMiles = '';
  const distance = bookingData.quote.distance_allowance;
  formattedMiles += distance.distance_limit
    ? `${distance.distance_limit * bookingData.quote.rental_days_count} `
    : `${t('fe_es_vehicle_page:unlimited')} `;
  formattedMiles += `${distance.distance_unit}s `;
  formattedMiles += t('fe_es_vehicle_page:included');
  let formattedIncrease;
  if (distance.distance_limit) {
    formattedIncrease = new Intl.NumberFormat('us-EN', {
      style: 'currency',
      currency: bookingData.quote.currency_code,
    }).format(distance.additional_distance_fee);
    formattedIncrease += ` / ${distance.distance_unit} `;
    formattedIncrease += t('fe_es_vehicle_page:additional_miles');
  }

  return { formattedMiles, formattedIncrease };
};

export default formatMilesLimit;
